import type { SortType } from '@lt/api/dist/methods/hotelReviews/types';
import type { Field, Order } from 'src/components/Sorting/types';

export const getSortingType = ({
  order,
  field,
}: {
  order: Order;
  field: Field;
}): SortType => {
  if (order === 'desc' && field === 'date') return 'new';
  if (order === 'asc' && field === 'date') return 'old';
  if (order === 'desc' && field === 'rating') return 'good';
  if (order === 'asc' && field === 'rating') return 'bad';
  return 'new';
};
